import { createSvgIcon } from '@mui/material/utils'

export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M 12.4 4.5 c 0.4 0.2 0.6 0.5 0.6 1 v 13 a 1 1 0 0 1 -1.6 0.8 l -4.5 -3.6 H 2.4 a 1 1 0 0 1 -1 -1 V 9.3 c 0 -0.6 0.4 -1 1 -1 h 4.5 L 11.4 4.7 a 1 1 0 0 1 1 -0.2 Z m -1.4 3 L 8 10 a 1 1 0 0 1 -0.7 0.3 H 3.4 v 3.4 h 3.9 l 0.6 0.3 l 3.1 2.5 v -9 Z m 8.7 -0.6 a 1 1 0 0 1 1.3 0.3 c 2 3 2.2 7 0.4 10.6 a 1 1 0 0 1 -1.8 -0.9 a 9 9 0 0 0 -0.3 -8.7 a 1 1 0 0 1 0.4 -1.3 Z M 16 8.7 a 1 1 0 0 1 1.4 0.2 c 1.7 2 2 4.8 0.3 7.2 a 1 1 0 0 1 -1.6 -1.1 c 1 -1.7 1 -3.5 -0.2 -4.9 a 1 1 0 0 1 0.1 -1.4 Z"
  />,
  'Volume5'
)
